var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tw-flex tw-flex-col tw-gap-3 lg:tw-gap-4"},[_c(_setup.AtomText,{attrs:{"tag":"h1","font":"robotoBold","textSizeMobile":"xl","textSizeDesktop":"2xl"}},[_vm._v(" "+_vm._s(_setup.props.title)+" ")]),_c(_setup.AtomDescriptionNoHtml,{attrs:{"description":_vm.description}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }